import Cookies from 'universal-cookie';
import { useEffect } from 'react';
import { initAmplitude } from '@src/analytics/amplitude';
import { initiateClientDatadogLogs } from '@src/utils/analytics';
import { onCLS, onLCP, onTTFB, onFCP, onINP } from 'web-vitals'; // Import specific Web Vitals metrics
import { ampli } from '@src/analytics/ampli';

const initiatePermanceTracking = (analyticsConsent: boolean) => {
  if (!analyticsConsent) {
    console.log('Analytics consent not given. Skipping performance tracking.');
    return;
  }

  if (typeof window !== 'undefined' && window.performance) {
    try {
      onCLS((metric) => {
        // Cumulative Layout Shift (CLS)
        const url = window.location.pathname;
        ampli.ruterNoWebVitalsCls({
          CLS: metric.value,
          rating: metric.rating,
          url,
        });
      });

      onLCP((metric) => {
        // Largest Contentful Paint (LCP)
        const url = window.location.pathname;
        ampli.ruterNoWebVitalsLcp({
          LCP: metric.value,
          rating: metric.rating,
          url,
        });
      });

      onINP((metric) => {
        // Interaction to Next Paint (INP)
        const url = window.location.pathname;
        ampli.ruterNoWebVitalsInp({
          INP: metric.value,
          rating: metric.rating,
          url,
        });
      });

      onFCP((metric) => {
        // First Contentful Paint (FCP)
        const url = window.location.pathname;
        ampli.ruterNoWebVitalsFcp({
          FCP: metric.value,
          rating: metric.rating,
          url,
        });
      });

      onTTFB((metric) => {
        // Time to First Byte (TTFB)
        const url = window.location.pathname;

        ampli.ruterNoWebVitalsTtfb({
          TTFB: metric.value,
          rating: metric.rating,
          url,
        });
      });

      const observeNavigationTiming = () => {
        try {
          const observer = new PerformanceObserver((list) => {
            const entries = list.getEntriesByType('navigation');
            if (entries.length > 0) {
              const navTiming = entries[0];
              const loadTime = navTiming.loadEventEnd - navTiming.startTime;
              const domContentLoadedTime =
                navTiming.domContentLoadedEventEnd - navTiming.startTime;
              const ttfb = navTiming.responseStart - navTiming.requestStart;

              const url = window.location.pathname;
              ampli.ruterNoWebVitalsNavigationTiming({
                loadTime,
                domContentLoadTime: domContentLoadedTime,
                url,
              });
            }
            observer.disconnect();
          });

          observer.observe({ type: 'navigation', buffered: true });
        } catch (error) {
          console.error('Error observing navigation timing:', error);
        }
      };

      observeNavigationTiming();
    } catch (e) {
      console.error('Error during performance tracking initialization:', e);
    }
  } else {
    console.warn('Performance API not supported in this environment.');
  }
};

export default function StoreInitializer() {
  const cookies = new Cookies();
  const analyticsConsent = cookies?.get('r_consents')?.analytics;

  useEffect(() => {
    initAmplitude(analyticsConsent);
    initiateClientDatadogLogs(analyticsConsent);
    initiatePermanceTracking(analyticsConsent);
  }, [analyticsConsent]);

  return null;
}
